var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 25.4375C0.666504 25.9898 1.11422 26.4375 1.6665 26.4375C2.21879 26.4375 2.6665 25.9898 2.6665 25.4375H0.666504ZM1.6665 1.4375V0.4375H0.666504V1.4375H1.6665ZM20.3332 1.4375L21.1768 1.97438C21.3728 1.66645 21.3854 1.27624 21.2098 0.956291C21.0341 0.636346 20.6982 0.4375 20.3332 0.4375V1.4375ZM20.3332 16.1042V17.1042C20.6982 17.1042 21.0341 16.9053 21.2098 16.5854C21.3854 16.2654 21.3728 15.8752 21.1768 15.5673L20.3332 16.1042ZM15.6665 8.77083L14.8228 8.23396C14.6144 8.56152 14.6144 8.98014 14.8228 9.30771L15.6665 8.77083ZM1.6665 2.4375H20.3332V0.4375H1.6665V2.4375ZM2.6665 25.4375V16.1042H0.666504V25.4375H2.6665ZM2.6665 16.1042V1.4375H0.666504V16.1042H2.6665ZM20.3332 15.1042H1.6665V17.1042H20.3332V15.1042ZM19.4895 0.900625L14.8228 8.23396L16.5102 9.30771L21.1768 1.97438L19.4895 0.900625ZM14.8228 9.30771L19.4895 16.641L21.1768 15.5673L16.5102 8.23396L14.8228 9.30771Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.9f0f51727c6dbbb8a469a53c285aa6ce.svg";
export { ForwardRef as ReactComponent };